import { RangeDatepicker } from './range-datepicker.js';

window.customElements.define('wc-range-datepicker', RangeDatepicker);
